import React, { useState, useEffect } from 'react';
import SEOHead from '../components/SEOHead';
import RelatedServices from '../components/RelatedServices';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    nails: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M21,9V7L15,1H5C3.89,1 3,1.89 3,3V7H1V9H3V15H1V17H3V21C3,22.11 3.89,23 5,23H19C20.11,23 21,22.11 21,21V17H23V15H21V9H23V7H21M19,21H5V3H13V7H19V21Z"/>
      </svg>
    ),
    schedule: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    playArrow: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M8 5v14l11-7z"/>
      </svg>
    ),
    insights: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M7.5 14H10v-1H7.5v1zm0 3H10v-1H7.5v1zm0-6H10V9H7.5v2zm4.5 6h5v-1H12v1zm0-3h5v-1H12v1zm0-3h5V9H12v2zM7 18h14V6H7v12zM5 4v16h16V4H5z"/>
      </svg>
    ),
    beauty: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M21,9V7L15,1H5C3.89,1 3,1.89 3,3V7H1V9H3V15H1V17H3V21C3,22.11 3.89,23 5,23H19C20.11,23 21,22.11 21,21V17H23V15H21V9H23V7H21M19,21H5V3H13V7H19V21Z"/>
      </svg>
    ),
    palette: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12,2C6.49,2 2,6.49 2,12C2,17.51 6.49,22 12,22C13.01,22 14,21.99 14,20.5C14,19.8 13.75,19.17 13.32,18.68C12.91,18.21 12.66,17.61 12.66,16.95C12.66,15.87 13.54,15 14.61,15H16.5C19.54,15 22,12.54 22,9.5C22,5.36 17.64,2 12,2M6.5,9C5.67,9 5,8.33 5,7.5C5,6.67 5.67,6 6.5,6C7.33,6 8,6.67 8,7.5C8,8.33 7.33,9 6.5,9M9.5,6C8.67,6 8,5.33 8,4.5C8,3.67 8.67,3 9.5,3C10.33,3 11,3.67 11,4.5C11,5.33 10.33,6 9.5,6M14.5,6C13.67,6 13,5.33 13,4.5C13,3.67 13.67,3 14.5,3C15.33,3 16,3.67 16,4.5C16,5.33 15.33,6 14.5,6M17.5,9C16.67,9 16,8.33 16,7.5C16,6.67 16.67,6 17.5,6C18.33,6 19,6.67 19,7.5C19,8.33 18.33,9 17.5,9Z"/>
      </svg>
    ),
    style: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M21,9V7L15,1H5C3.89,1 3,1.89 3,3V7H1V9H3V15H1V17H3V21C3,22.11 3.89,23 5,23H19C20.11,23 21,22.11 21,21V17H23V15H21V9H23V7H21M19,21H5V3H13V7H19V21Z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const NailSalonLanding = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  const [currentCallType, setCurrentCallType] = useState(0);
  
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: 'nail salon'
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const callExamples = [
    {
      type: "Gel Manicure",
      time: "Tuesday, 11:30 AM",
      customer: "I need a gel manicure for this Saturday, do you have any openings?",
      response: "I can schedule your gel manicure for Saturday at 1 PM. The service takes 45 minutes and includes nail art if desired. Would you like to add that?",
      outcome: "$65 gel manicure",
      color: "blue"
    },
    {
      type: "Pedicure & Manicure",
      time: "Friday, 2:45 PM",
      customer: "I want both a pedicure and manicure for my wedding next week",
      response: "Perfect! I can book your bridal package for next Tuesday at 10 AM. Our deluxe mani-pedi with French tips takes 2 hours. Congratulations!",
      outcome: "$120 bridal package",
      color: "blue"
    },
    {
      type: "Nail Art Design",
      time: "Wednesday, 4:20 PM",
      customer: "Do you do custom nail art? I want something special for my birthday",
      response: "We specialize in custom nail art! I can schedule you for Friday at 3 PM with our nail artist. We'll design something unique for your birthday celebration.",
      outcome: "$85 custom nail art",
      color: "blue"
    }
  ];

  const testimonials = [
    {
      quote: "Every nail appointment request gets immediate response. Our booking rate increased 68% since implementing the AI.",
      author: "Maria S.",
      business: "Luxe Nail Studio",
      result: "68% more bookings"
    },
    {
      quote: "The AI handles gel manicures, pedicures, and nail art bookings perfectly. Clients love the instant scheduling.",
      author: "Jenny L.",
      business: "Polished Perfection",
      result: "$42,000 additional revenue"
    },
    {
      quote: "From quick touch-ups to full nail sets, every client call is handled professionally.",
      author: "Angela R.",
      business: "Nail Envy Salon",
      result: "Booked 4 weeks ahead"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCallType(prev => (prev + 1) % callExamples.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone) {
      alert('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: 'nail salon' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };
  
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <MaterialIcon name="close" className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    );
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Receptioneer.ai - AI Receptionist for Nail Salons",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web Browser",
    "description": "AI-powered receptionist service specifically designed for nail salons. Handles calls, books appointments, and captures leads 24/7.",
    "offers": {
      "@type": "Offer",
      "price": "399",
      "priceCurrency": "USD",
      "priceValidUntil": "2025-12-31",
      "availability": "https://schema.org/InStock"
    },
    "provider": {
      "@type": "Organization",
      "name": "Receptioneer.ai",
      "url": "https://receptioneer.ai"
    }
  };

  return (
    <>
      <SEOHead
        title="AI Receptionist for Nail Salons | Never Miss Another Nail Appointment"
        description="Get more nail salon bookings with an AI receptionist that handles calls 24/7. Books manicures, pedicures, and nail art automatically. Starting at $399/month."
        keywords="nail salon ai receptionist, nail salon booking system, manicure appointment booking, pedicure scheduling, nail art appointments, beauty salon phone service"
        canonical="https://receptioneer.ai/nailsalon"
        ogTitle="AI Receptionist for Nail Salons - Never Miss Another Appointment"
        ogDescription="AI receptionist that handles nail salon calls 24/7. Books manicures, pedicures, nail art automatically. Perfect for nail salons and beauty studios."
        ogImage="https://receptioneer.ai/images/nailsalon-og.jpg"
        structuredData={structuredData}
      />
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Try Live Demo
              </a>
              <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Login
              </button>
            </div>
          </div>
        </header>
        
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white">
          <div className="max-w-6xl mx-auto grid lg:grid-cols-2 min-h-[85vh] items-center">
            <div className="px-6 py-12 lg:py-20">
              <div className="inline-flex items-center bg-blue-700 text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
                💅 For Nail Salons
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
                Never Miss Another
                <br />
                <span className="text-blue-200">Nail Appointment</span>
              </h1>
              
              <p className="text-xl text-blue-100 mb-8 leading-relaxed">
                From gel manicures to custom nail art, your AI receptionist handles every call professionally. 
                <strong className="text-white">Books appointments, manages schedules, and captures clients 24/7.</strong>
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-12">
                <button 
                  onClick={() => setShowWaitlistModal(true)}
                  className="bg-white text-blue-900 hover:bg-blue-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                >
                  Get My Nail Salon AI →
                </button>
                
                <a
                  href="tel:+17863845350"
                  className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-blue-900 px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300"
                >
                  <MaterialIcon name="phone" className="w-5 h-5" />
                  Test It Live
                </a>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div className="text-center">
                  <div className="text-2xl font-black text-white">24/7</div>
                  <div className="text-blue-200 text-sm">Appointment booking</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">$399</div>
                  <div className="text-blue-200 text-sm">Per month</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">24hrs</div>
                  <div className="text-blue-200 text-sm">Setup time</div>
                </div>
              </div>
            </div>

            <div className="bg-blue-800 lg:bg-transparent px-6 py-12 lg:py-20">
              <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-md mx-auto">
                <div className="flex items-center gap-3 mb-6">
                  <div className={`w-4 h-4 rounded-full animate-pulse ${
                    callExamples[currentCallType].color === 'red' ? 'bg-red-500' :
                    callExamples[currentCallType].color === 'green' ? 'bg-green-500' : 'bg-blue-500'
                  }`}></div>
                  <span className="font-bold text-gray-900">{callExamples[currentCallType].type}</span>
                  <span className="text-xs text-gray-500">{callExamples[currentCallType].time}</span>
                </div>
                
                <div className="space-y-4 mb-6">
                  <div className="bg-gray-50 rounded-lg p-3">
                    <div className="text-xs text-gray-600 font-semibold mb-1">Client:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].customer}"</div>
                  </div>
                  
                  <div className={`rounded-lg p-3 ${
                    callExamples[currentCallType].color === 'red' ? 'bg-red-50' :
                    callExamples[currentCallType].color === 'green' ? 'bg-green-50' : 'bg-blue-50'
                  }`}>
                    <div className={`text-xs font-semibold mb-1 ${
                      callExamples[currentCallType].color === 'red' ? 'text-red-600' :
                      callExamples[currentCallType].color === 'green' ? 'text-green-600' : 'text-blue-600'
                    }`}>AI Response:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].response}"</div>
                  </div>
                </div>
                
                <div className="text-center">
                  <div className={`text-lg font-black ${
                    callExamples[currentCallType].color === 'red' ? 'text-red-600' :
                    callExamples[currentCallType].color === 'green' ? 'text-green-600' : 'text-blue-600'
                  }`}>{callExamples[currentCallType].outcome}</div>
                  <div className="text-xs text-gray-500">Appointment booked</div>
                </div>

                <div className="flex justify-center gap-2 mt-6">
                  {callExamples.map((_, index) => (
                    <div 
                      key={index}
                      className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                        currentCallType === index ? 'bg-blue-600' : 'bg-gray-300'
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Every Type of <span className="text-blue-900">Nail Service</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              <div className="bg-red-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="nails" className="w-8 h-8 text-red-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Manicure Services</h3>
                <ul className="space-y-2 text-gray-700 mb-6">
                  <li>• Classic manicures</li>
                  <li>• Gel manicures</li>
                  <li>• French manicures</li>
                  <li>• Nail strengthening</li>
                  <li>• Cuticle care</li>
                </ul>
              </div>

              <div className="bg-blue-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="beauty" className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Pedicure Services</h3>
                <ul className="space-y-2 text-gray-700 mb-6">
                  <li>• Relaxing pedicures</li>
                  <li>• Spa pedicures</li>
                  <li>• Gel pedicures</li>
                  <li>• Callus removal</li>
                  <li>• Foot massages</li>
                </ul>
              </div>

              <div className="bg-green-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="palette" className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Nail Art & Extensions</h3>
                <ul className="space-y-2 text-gray-700 mb-6">
                  <li>• Custom nail art</li>
                  <li>• Acrylic extensions</li>
                  <li>• Gel extensions</li>
                  <li>• Nail stamping</li>
                  <li>• Special occasion nails</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Nail Salons Are Growing With <span className="text-blue-900">AI Receptionists</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="bg-white rounded-3xl p-8 shadow-sm">
                  <div className="flex items-center gap-3 mb-6">
                    <MaterialIcon name="style" className="w-8 h-8 text-blue-600" />
                    <div>
                      <div className="font-bold text-gray-900">{testimonial.author}</div>
                      <div className="text-sm text-gray-600">{testimonial.business}</div>
                    </div>
                  </div>
                  <p className="text-gray-700 mb-6 italic">"{testimonial.quote}"</p>
                  <div className="bg-blue-50 rounded-xl p-4 text-center">
                    <div className="text-lg font-black text-blue-900">{testimonial.result}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pricing */}
        <section className="py-16 px-6 bg-blue-900 text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-8">
              One Nail Set Pays for Everything
            </h2>
            
            <div className="bg-white/10 rounded-3xl p-8 mb-8">
              <div className="text-6xl lg:text-7xl font-black mb-4">$399</div>
              <div className="text-xl text-blue-100 mb-6">per month • unlimited calls • all services</div>
              
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="w-full bg-white text-blue-900 hover:bg-blue-50 py-4 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Get My Nail Salon AI →
              </button>
            </div>
            
            <p className="text-blue-200">Ready in 24 hours • Cancel anytime • ROI guaranteed</p>
          </div>
        </section>

        {/* Waitlist Modal */}
        <Modal
          isOpen={showWaitlistModal}
          onClose={() => setShowWaitlistModal(false)}
          title="Get Your Nail Salon AI"
        >
          {waitlistSuccess ? (
            <div className="text-center">
              <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">You're all set!</h3>
              <p className="text-gray-600">We'll have your nail salon AI ready within 24 hours of launch.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  required
                  value={waitlistData.name}
                  onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="e.g. Maria Santos"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
                <input
                  type="email"
                  required
                  value={waitlistData.email}
                  onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="maria@luxenailstudio.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Phone</label>
                <input
                  type="tel"
                  required
                  value={waitlistData.phone}
                  onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="(555) 123-4567"
                />
              </div>
              
              <button
                onClick={handleWaitlistSubmit}
                disabled={waitlistLoading}
                className="w-full bg-blue-900 hover:bg-blue-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {waitlistLoading ? 'Setting Up Your AI...' : 'Get My Nail Salon AI'}
              </button>
            </div>
          )}
        </Modal>

        {/* Related Services */}
        <RelatedServices currentService="/nailsalon" />

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default NailSalonLanding;